import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CarePathwayStep,
  ResultCategory,
  SummaryItem,
  TimeHorizonKey,
} from '../../../services/result-data/result-data.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { CarePathwayComponent } from './care-pathway/care-pathway.component';
import { MatDividerModule } from '@angular/material/divider';
import { SummaryComponent } from './summary/summary.component';
import { CarePathwayStepComponent } from './care-pathway-step/care-pathway-step.component';
import { SelectedStepService } from '../../../services/selected-step/selected-step.service';
import { ResultCategoryViewComponent } from './result-category-view/result-category-view.component';

@Component({
  selector: 'app-results',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    CarePathwayComponent,
    CarePathwayStepComponent,
    MatDividerModule,
    SummaryComponent,
    ResultCategoryViewComponent,
  ],
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
})
export class ResultsComponent implements OnInit {
  @Input() categories!: ResultCategory[];
  @Input() carePathwaySteps!: CarePathwayStep[];
  @Input() timeHorizon!: TimeHorizonKey;
  @Input() summaryItems!: SummaryItem[];

  @ViewChild(CarePathwayComponent) private carePathway?: CarePathwayComponent;

  selectedCarePathwayStepIndex: number | null = null;

  constructor(private readonly _selectedStepService: SelectedStepService) {}

  ngOnInit(): void {
    this._selectedStepService.selectedStepIndex.subscribe((step) => {
      this.selectedCarePathwayStepIndex = step;
    });
  }

  onCarePathwayStepSelected(stepIndex: number) {
    this.selectedCarePathwayStepIndex = stepIndex;
  }

  private _previousTabIndex = 0;
  onTabChange(event: MatTabChangeEvent): void {
    if (event.index === 0 && this._previousTabIndex !== 0) {
      queueMicrotask(() => this.carePathway?.resetView());
    }
    this._previousTabIndex = event.index;
  }
}
